import { Box } from '@mui/material'
import {
    MaterialReactTable,
    type MRT_TableInstance,
} from 'material-react-table'
import { type UploadRow } from '../interface'

interface UploadManagerTableProps {
    table: MRT_TableInstance<UploadRow>
}

export const UploadManagerTable = ({
    table,
}: UploadManagerTableProps): React.ReactElement => {
    return (
        <Box
            id="upload-manager-table-container"
            sx={{
                px: '3px',
                pb: 2,
                height: 'calc(100% - 132px)',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <MaterialReactTable table={table} />
        </Box>
    )
}
